import { useEffect } from "react";
import { match, P } from "ts-pattern";
import { AnalysisTable } from "@/components/admin/analysis/AnalysisTable";
import { ExecuteAnalysisButton } from "@/components/admin/analysis/ExecuteAnalysisButton";
import PageHeader from "@/components/admin/header/PageHeader";
import { useAnalyses } from "@/hooks/useAnalyses";
import { useCategoryTrees } from "@/hooks/useCategoryTrees";
import { showError } from "@/utils/notification";

const ExecuteAnalysisPage = () => {
  const { categoryTrees, getCategoryTreeVersion } = useCategoryTrees();
  const { analyses, error: fetchAnalysesError, isLoading: isLoadingAnalyses, isAnalysisRunning } = useAnalyses();

  useEffect(() => {
    if (fetchAnalysesError) showError("分析一覧の取得に失敗しました。");
  }, [fetchAnalysesError]);

  return (
    <>
      <PageHeader hasBack={false} title="分析" />
      <h2 style={{ marginTop: 0 }}>分析実行履歴</h2>
      {analyses && (
        <AnalysisTable
          analyses={analyses}
          isLoading={isLoadingAnalyses}
          getCategoryTreeVersion={getCategoryTreeVersion}
        />
      )}

      <h2>分析実行</h2>
      {match(categoryTrees)
        .with(undefined, () => <></>)
        .with(P.when((categoryTrees) => categoryTrees.length === 0), () => "カテゴリが作成されていません")
        .otherwise((categoryTrees) => (
          <ExecuteAnalysisButton categoryTrees={categoryTrees} isAnalysisRunning={isAnalysisRunning} />
        ))}
    </>
  );
};

export default ExecuteAnalysisPage;
